export interface ISort {
  unsorted: boolean;
  sorted: boolean;
  empty: boolean;
}

export interface IPageable {
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  sort: ISort;
  unpaged: boolean;
}

export interface IPageInfo {
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
  numberOfElements: number;
  last: boolean;
  first: boolean;
  empty: boolean;
  sort?: ISort;
  pageable?: IPageable;
  content?: unknown;
}

export class POPage<T> implements IPageInfo {
  totalPages = 0;
  totalElements = 0;
  size = 0;
  number = 0;
  numberOfElements = 0;
  last = true;
  first = true;
  empty = true;

  public content: T[] = [];
}
